import React, { useCallback, useRef, useEffect } from 'react'
import styled from 'styled-components'

type Props = {
    children: React.ReactNode
    className?: string
    onClose: () => void
    /** The className or the id, ** CANNOT START WITH NUMBER *** */
    excludeId?: string | string[]
    isOpen: boolean
}

const OnClickOutsideWrapper = ({ children, onClose, isOpen, excludeId, className }: Props): JSX.Element => {
    const containerRef = useRef(null)

    const handleClickOutside = useCallback(
        (e): void => {
            if (!containerRef.current?.contains(e.target)) {
                const el = e.target

                const excludeIds = Array.isArray(excludeId) ? excludeId : [excludeId]

                if (excludeId && excludeIds.some(id => el.closest(`.${id}`) || el.closest(`#${id}`))) {
                    window.removeEventListener('mousedown', handleClickOutside)
                    window.removeEventListener('touchstart', handleClickOutside)

                    return
                }
                onClose?.()

                window.removeEventListener('mousedown', handleClickOutside)
                window.removeEventListener('touchstart', handleClickOutside)
            }
        },
        [onClose, excludeId]
    )

    const removeEventListener = useCallback((): void => {
        window.removeEventListener('mousedown', handleClickOutside)
        window.removeEventListener('touchstart', handleClickOutside)
    }, [handleClickOutside])

    useEffect(() => {
        if (isOpen) {
            window.addEventListener('mousedown', handleClickOutside)
            window.addEventListener('touchstart', handleClickOutside)
        } else {
            removeEventListener()
        }

        return () => {
            removeEventListener()
        }
    }, [handleClickOutside, isOpen, removeEventListener])

    return (
        <OnClickOutsideWrapperContainer className={className} ref={containerRef}>
            {children}
        </OnClickOutsideWrapperContainer>
    )
}

export default OnClickOutsideWrapper

export const OnClickOutsideWrapperContainer = styled.div`
    width: fit-content;
    height: fit-content;
`
